import React from 'react';
import './style.scss';

const ProfileComponent: React.FC = () => {
  return (
    <div className="ProfileComponent">
      <h1>Profile is working...</h1>
    </div>
  );
}

export default ProfileComponent;
